<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <button @click="goBack" class="btn btn-secondary mb-3">
          <font-awesome-icon icon="arrow-left" /> Zurück zur Übersicht
        </button>
      </div>
      <div class="col-12 col-md-8 col-lg-6">
        <h2 class="text-center mb-4">Kunden anlegen</h2>
        <form @submit.prevent="submitForm" class="form-modern">
          <!-- Vorname -->
          <div class="form-group mb-4">
            <label for="FirstName">Vorname:</label>
            <input type="text" v-model="customer.FirstName" id="FirstName" class="form-control"
              placeholder="Vorname eingeben" required>
          </div>

          <!-- Nachname -->
          <div class="form-group mb-4">
            <label for="LastName">Nachname:</label>
            <input type="text" v-model="customer.LastName" id="LastName" class="form-control"
              placeholder="Nachname eingeben" required>
          </div>

          <!-- Straße -->
          <div class="form-group mb-4">
            <label for="Street">Straße:</label>
            <input type="text" v-model="customer.Street" id="Street" class="form-control" placeholder="Straße eingeben"
              required>
          </div>

          <!-- PLZ -->
          <div class="form-group mb-4">
            <label for="PostalCode">PLZ:</label>
            <input type="text" v-model="customer.PostalCode" id="PostalCode" class="form-control"
              placeholder="PLZ eingeben" required>
          </div>

          <!-- Stadt -->
          <div class="form-group mb-4">
            <label for="City">Stadt:</label>
            <input type="text" v-model="customer.City" id="City" class="form-control" placeholder="Stadt eingeben"
              required>
          </div>

          <!-- E-Mail -->
          <div class="form-group mb-4">
            <label for="Email">E-Mail:</label>
            <input type="email" v-model="customer.Email" id="Email" class="form-control" placeholder="E-Mail eingeben"
              required>
          </div>

          <!-- Telefon -->
          <div class="form-group mb-4">
            <label for="Phone">Telefon:</label>
            <input type="text" v-model="customer.Phone" id="Phone" class="form-control" placeholder="Telefon eingeben"
              required>
          </div>

          <!-- Provision -->
          <div class="form-group mb-4">
            <label for="Commission">Provision:</label>
            <input type="number" step="0.01" v-model="customer.Commission" id="Commission" class="form-control"
              placeholder="Provision eingeben" required>
          </div>

          <!-- Auszahlungsart -->
          <div class="form-group mb-4">
            <label for="Payout">Auszahlungsart:</label>
            <select v-model="customer.Payout" id="Payout" class="form-control" required>
              <option value="" disabled selected>Bitte wählen</option>
              <option value="Bar">Bar</option>
              <option value="Überweisung">Überweisung</option>
            </select>
          </div>


          <!-- IBAN -->
          <div class="form-group mb-4">
            <label for="Iban">IBAN:</label>
            <input type="text" v-model="customer.Iban" id="Iban" class="form-control" placeholder="IBAN eingeben">
          </div>

          <!-- Bank -->
          <div class="form-group mb-4">
            <label for="Bank">Bank:</label>
            <input type="text" v-model="customer.Bank" id="Bank" class="form-control" placeholder="Bank eingeben">
          </div>

          <button type="submit" class="btn btn-primary w-100">Kunde speichern</button>
        </form>

        <!-- Optional: Nachricht bei Erfolg oder Fehler anzeigen -->
        <div v-if="message" class="alert alert-info mt-4">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  data() {
    return {
      customer: {
        FirstName: '',
        LastName: '',
        Street: '',
        PostalCode: '',
        City: '',
        Email: '',
        Phone: '',
        Commission: 0,
        Payout: 0,
        Iban: '',
        Bank: ''
      },
      message: ''  // Feedback-Nachricht für den Benutzer
    };
  },
  methods: {
    async submitForm() {
      try {
        const response = await axios.post('/customers', this.customer);

        console.log('Kunde gespeichert:', response.data);

        // Reset & Erfolgsmeldung
        this.customer = {
          FirstName: '',
          LastName: '',
          Street: '',
          PostalCode: '',
          City: '',
          Email: '',
          Phone: '',
          Commission: 0,
          Payout: 0,
          Iban: '',
          Bank: ''
        };
        this.message = 'Kunde erfolgreich gespeichert!';
        this.$router.push('/customers');
      } catch (error) {
        console.error('Fehler:', error);
        this.message = 'Es gab ein Problem beim Speichern des Kunden: ' + (error.response?.data?.message || error.message);
      }
    },
    goBack() {
      this.$router.push('/customers');
    }
  }
};
</script>


<style scoped>
.container {
  margin-top: 50px;
}

h2 {
  font-weight: bold;
  color: var(--primary-color);
}

.form-modern {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.form-group label {
  font-weight: bold;
}

.form-control {
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: border-color 0.3s ease;
}

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Einheitlicher Zurück-Button (grau und oben links) */
.btn {
  background-color: #6c757d;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #5a6268;
}

.alert {
  text-align: center;
  font-size: 16px;
}
</style>
